// import { h } from 'preact';
import { accessNested, asList, parseDate } from 'utils/utils';
import { maybeHandle } from 'utils/gdpr/maybeHandle';
import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';
import * as actions from 'store/actions';
// import { getStaticData } from 'utils/staticData';
// import { staticPixels } from 'pages/bolt_features';
import cached from 'utils/cached';

if (USE_LEGACY_TRACKING) {
	const isProd = () => {
		if (typeof window === 'undefined') {
			return false;
		}
		// Not checking for stage - stage should behave as much like prod as possible
		// if (__IS_LOCAL__ || __IS_DEMO__ || window.location.href.includes('stage.showtimes-static')) {
		if (__IS_LOCAL__ || __IS_DEMO__) {
			return false;
		}
		return true;
	};

	const trackedEvents = {};

	if (typeof window !== 'undefined') {
		window.tealiumTrackingAllowed = function () {
			window.preventCookies = false;

			// Update  the firstVisit value in the store
			try {
				let isFirstVisit = localStorage.getItem('isFirstVisit') !== 'false';
				if (isFirstVisit) {
					localStorage.setItem('isFirstVisit', 'false');
				} else {
					const user = Store.get().user;
					if (user) user.set({ isFirstVisit: false });
				}
			} catch (err) { }
		};
	}

	let tealiumTrackingBase = {};
	const getTealiumTrackingData = (data) => {
		return Object.assign({}, tealiumTrackingBase, data);
	};
	const tealiumTheaterData = (theater) => {
		if (!theater || typeof theater !== 'object') {
			let predicate = () => true;
			if (typeof theater === 'string') {
				predicate = t => t.id === theater;
			}
			theater = Store.get().showtimes.data.find(predicate);
		}
		if (!theater) {
			return;
		}
		return {
			cinemaName: theater.name,
			cinemaChain: accessNested(theater, 'chain.name'),
			location: accessNested(theater, 'address.intl.city') || accessNested(theater, 'address.local.city')
		};
	};
	const tealiumPageViewTrack = () => {
		if (!window.utag || typeof window.utag.view !== 'function') {
			return;
		}
		window.utag.view(getTealiumTrackingData());
	};
	const tealiumActionTrack = (data) => {
		if (!window.utag || typeof window.utag.link !== 'function') {
			return;
		}
		window.utag.link(getTealiumTrackingData(data));
	};

	const languages = {
		gb: 'en',
		us: 'en',
		au: 'en'
	};
	const tealiumProfiles = {
		'au-powster': ['au'],
		'emea-powster': [
			'ad', 'ae', 'al', 'ao', 'at', 'ba', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bw', 'by', 'cd', 'cf',
			'ch', 'ci', 'cm', 'cv', 'cy', 'cz', 'de', 'dj', 'dk', 'dz', 'ee', 'eg', 'eh', 'er', 'es', 'et',
			'fi', 'fo', 'fr', 'ga', 'gb', 'ge', 'gg', 'gh', 'gi', 'gm', 'gn', 'gq', 'gr', 'gw', 'hr', 'hu',
			'ie', 'il', 'im', 'iq', 'ir', 'is', 'it', 'je', 'jo', 'ke', 'km', 'kw', 'lb', 'li', 'lr', 'ls',
			'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mde', 'mg', 'mk', 'ml', 'mr', 'mt', 'mu', 'mw',
			'mz', 'na', 'ne', 'ng', 'nl', 'no', 'om', 'pl', 'ps', 'pt', 'qa', 'ro', 'rs', 'rw', 'sa', 'sd',
			'se', 'si', 'sk', 'sm', 'sn', 'so', 'st', 'sy', 'sz', 'td', 'tg', 'tn', 'tr', 'tz', 'ua', 'ug',
			'va', 'xm', 'ye', 'za', 'zm', 'zw', 'intl'
		]
	};

	//
	// Other tracking
	//

	const getPowsterCustomGA = cached(() => {
		let powsterCustomGA = Store.get().appData?.apis?.tracking?.powsterGATracking;
		return asList(powsterCustomGA).filter(id => id.startsWith('UA-') || id.startsWith('G-'));
	});

	// Powster Custom GA Tracking

	const firePowsterCustomEvent = (action, category, label, options) => {
		if (typeof powsterGtag !== 'function') {
			return;
		}

		let tagIds = getPowsterCustomGA();

		if (!tagIds || !tagIds.length) return;

		const store = Store.get();
		const region = accessNested(store, 'appData.meta.region.slug', '');
		const title = accessNested(store, 'appData.meta.title.locale', '');
		const studio = accessNested(store, 'appData.meta.studio.slug');
		const app = title + ' - ' + region.toUpperCase();
		const debug_mode = !isProd();

		const args = {
			send_to: tagIds,
			event_stream: app,
			event_category: category,
			event_label: label,
			event_region: region,
			event_studio: studio,
			region: region,
			allow_google_signals: false,
			debug_mode: debug_mode
		};

		Object.assign(args, options);
		const powGtagCat = accessNested(store, 'appData.apis.tracking.powsterGATracking.trackingCategory', 'PERFORMANCE');
		maybeHandle(powGtagCat, () => window.powsterGtag('event', action, args), true);
	};

	const firePowsterGtagPageView = (pageId) => {
		if (typeof powsterGtag !== 'function') {
			return;
		}
		let tagIds = getPowsterCustomGA();
		if (!tagIds) return;

		const store = Store.get();
		const region = accessNested(store, 'appData.meta.region.slug', '');
		const title = accessNested(store, 'appData.meta.title.locale', '');
		const studio = accessNested(store, 'appData.meta.studio.slug');
		const app = title + ' - ' + region.toUpperCase();

		pageId = pageId.toLowerCase();

		if (pageId.startsWith('bolt')) {
			pageId = pageId.substring(4);
		}

		if (pageId === 'showtimes') {
			pageId = 'tickets';
		}

		const debug_mode = !isProd();

		const powGtagCat = accessNested(store, 'appData.apis.tracking.powsterGATracking.trackingCategory', 'PERFORMANCE');

		maybeHandle(powGtagCat, () => {
			tagIds.forEach(tagId => {
				window.powsterGtag('config', tagId, {
					page_title: pageId,
					page_path: pageId,
					anonymize_ip: 'true',
					custom_map: {
						'dimension1': 'region'
					},
					event_stream: app,
					event_region: region,
					event_studio: studio,
					allow_google_signals: false,
					region: region,
					debug_mode: debug_mode,
					cookie_flags: (typeof window !== 'undefined' && window !== window.top) ? 'SameSite=None; Secure' : ''
				});
			});
		}, true);

		if (pageId === 'gallery') {
			Store.emit(actions.GALLERY_VIEW_IMAGE, 1);
		}
	};

	const firePowsterGtagLoad = () => {
		firePowsterCustomEvent('timing_complete', 'pageLoad', '', { name: 'load', 'value': Math.round(window.startLoadTime) });
	};

	const updateDataLayerPageView = (pageId) => {
		let cleanId = pageId.replace(/^bolt(.)/, (m, c) => c.toLowerCase());

		let params = {
			event: 'page_load',
			pageId: cleanId
		};
		if (pageId === 'videos') {
			params.event = 'trailer-view';
		}
		let store = Store.get();
		let sonyDataLayer = store.appData?.options?.sonyFeatures?.sonyDataLayer;
		if (sonyDataLayer) {
			let movieTitle = sonyDataLayer.pageTitle || (store.appData?.meta?.title?.slug || '').replace(/-/g, '');
			let currentPageSlug = pageId.replace(/^bolt/, '');
			params.page_title = `${movieTitle} ${currentPageSlug}`;
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(params);
	};

	const fireLionsgateTracking = () => {
		const store = Store.get();
		const lionsgateAdswerve = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		if (!lionsgateAdswerve) return;

		const locale = accessNested(store, 'appData.meta.title.locale', '');
		const { dxNumber, genres, distributionWindow } = lionsgateAdswerve;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'dataLayer-initialized',
			'titleName': locale,
			'dxNumbers': dxNumber,
			'genre': genres,
			'environment': 'prod',
			'distributionWindow': distributionWindow,
			'pageContentType': 'movie',
			'siteType': 'standalone movie site'
		});
	};

	const fireLionsgateTicketClick = (screening, theater) => {
		const lionsgateAdswerve = accessNested(Store.get(), 'appData.apis.tracking.lionsgateAdswerve');
		if (!lionsgateAdswerve) return;

		const locale = accessNested(Store.get(), 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'movie_time_click',
			'content_title': locale,
			'theater_name': theater.name,
			'showtime_date': screening.date,
			'showtime_time': screening.time
		});
	};

	const fireLionsgateSelectTheater = (name) => {
		const lionsgateAdswerve = accessNested(Store.get(), 'appData.apis.tracking.lionsgateAdswerve');
		if (!lionsgateAdswerve) return;

		const locale = accessNested(Store.get(), 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'theater_click',
			'content_title': locale,
			'theater_name': name
		});
	};

	const fireLionsgateConversion = (data) => {
		const locale = accessNested(Store.get(), 'appData.meta.title.locale', '');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'aggregator_click',
			'content_title': locale,
			'click_text': data.provider,
			'theater_name': data.theater.name,
			'showtime_date': data.date,
			'showtime_time': data.time
		});
	};
	const fireSonyConversion = (data) => {
		window.dataLayer = window.dataLayer || [];
		let retailer = data.provider;
		if (retailer === 'direct') {
			retailer = data.theater.chain?.slug || retailer;
		}
		window.dataLayer.push({
			event: 'ticket_click',
			event_label: retailer,
			event_label_2: data.time,
			event_label_3: data.theater.name
		});
	};

	// TODO: move that function to a separate to be able to override at studio level (cleaner sony/lionsgate handling)
	const updateDataLayerConversion = (data) => {
		let store = Store.get();
		const lionsgateAdswerve = store.appData?.apis?.tracking?.lionsgateAdswerve;
		if (lionsgateAdswerve) {
			fireLionsgateConversion(data);
			return;
		}
		const sonyDataLayer = store.appData?.options?.sonyFeatures?.sonyDataLayer;
		if (sonyDataLayer) {
			fireSonyConversion(data);
			return;
		}

		const theaterCity = accessNested(data, 'theater.address.local.city') || accessNested(data, 'theater.address.intl.city') || '';
		const theaterState = accessNested(data, 'theater.address.local.state') || accessNested(data, 'theater.address.intl.state') || '';
		const theaterStreet = accessNested(data, 'theater.address.local.street') || accessNested(data, 'theater.address.intl.street') || '';
		const theaterCountry = accessNested(data, 'theater.address.local.country') || accessNested(data, 'theater.address.intl.country') || '';
		const theaterFullAddress = theaterStreet + ', ' + theaterCity;
		const theaterUrl = accessNested(data, 'theater.url', '');

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ticket_click',
			city: theaterCity,
			location: {
				country: theaterCountry,
				fullAddress: theaterFullAddress,
				address: theaterStreet,
				city: theaterCity,
				state: theaterState
			},
			theatre: data.theater.name,
			exhibitor: theaterUrl,
			day: data.date,
			time: data.time
		});
	};

	const updateDataLayerShare = (label) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'social-share-click',
			socialSite: label
		});
	};

	const updateDataLayerCitySearch = (data) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'city_changed',
			city: data.city
		});
	};

	const updateDataLayerFilters = (filters) => {
		window.dataLayer = window.dataLayer || [];
		const timeOfDay = filters.time && filters.time.join(', ') || 'all';
		const format = filters.format && filters.format.join(', ') || 'all';
		window.dataLayer.push({
			event: 'session_change',
			filterDate: filters.date?.join('') || '',
			filterTimeOfDay: timeOfDay,
			filterFormat: format
		});
	};

	// Flooglight tracking

	const fireGtag = (action, data = {}) => {
		if (!window.gtag) return;

		if (typeof data.allow_custom_scripts === 'undefined') {
			data.allow_custom_scripts = true;
		}

		window.gtag('event', action, data);
	};

	// Event listeners
	Store.on('LANDING', ({ page }) => {
		setTimeout(() => {
			const disableDefaultPageView = accessNested(Store.get(), 'appData.options.disablePageViewTracking');
			if (!disableDefaultPageView) {
				firePowsterGtagPageView(page);
			}
			firePowsterGtagLoad();
		}, 0);
	});

	Store.on('LANDING', () => {
		let appData = Store.get().appData;
		let code = appData?.meta?.title?.alternateSlug || appData?.meta?.title?.slug;
		let tealium = appData?.options?.enableTealium;
		if (!code || !tealium) {
			return;
		}

		let regionData = accessNested(appData, 'meta.region.slug', '').split('_');
		let country = regionData[0];
		if (country === 'mde') {
			country = 'xm';
		}
		let language = regionData.pop();
		// Check if the region code has a listed language
		language = languages[language] || language;
		tealiumTrackingBase = {
			movieName: accessNested(appData, 'meta.title.en'),
			country: country,
			language: language,
			propertyCode: code
		};

		window.utag_data = { propertyCode: code };
		let type = 'dev';
		if (!__IS_LOCAL__ && !__IS_DEMO__) {
			type = location.href.indexOf('stage.showtimes-static') !== -1 ? 'qa' : 'prod';
		}

		let profile = Object.keys(tealiumProfiles).find(profile => tealiumProfiles[profile].includes(country));
		if (!profile) {
			return;
		}
		let scriptUrl = '//tags.disneyinternational.com/tealium/' + profile + '/' + type + '/utag.js';

		let script = document.createElement('script');
		script.onload = tealiumPageViewTrack;
		script.async = true;
		script.src = scriptUrl;
		document.body.appendChild(script);
	});

	Store.on('LANDING', () => {
		const lionsgateAdswerve = accessNested(Store.get(), 'appData.apis.tracking.lionsgateAdswerve');
		if (lionsgateAdswerve) {
			fireLionsgateTracking();
		}

		const gtm = accessNested(Store.get(), 'appData.apis.tracking.googleTagManager', {});
		if (gtm.uaId && gtm.landingConversion) {
			fireGtag('conversion', {
				'send_to': gtm.landingConversion
			});
		}
	});

	Store.on('SET_ACTIVE_PAGE', (activePage) => {
		const disableDefaultPageView = accessNested(Store.get(), 'appData.options.disablePageViewTracking');
		if (!disableDefaultPageView) {
			firePowsterGtagPageView(activePage);
		}
		updateDataLayerPageView(activePage);
	});

	Store.on('CALENDAR_CLICKED', ({ label }) => {
		firePowsterCustomEvent('calendar' + '-reminder_click', 'calendar-reminder', label);
	});

	Store.on('CLICKED_SHARE', ({ label }) => {
		firePowsterCustomEvent('social-share', 'social', label);
		updateDataLayerShare(label);
	});

	Store.on('CLICKED_MOBILE_NATIVE_SHARE', () => {
		firePowsterCustomEvent('social-share', 'social', 'mobile-native');
	});

	Store.on('CLICKED_FOLLOW', (name) => {
		firePowsterCustomEvent('social-follow', 'social', name);
	});

	Store.on('SYNOPSIS_DOWNLOAD_IMAGE', (imageName = 'onesheet.jpg') => {
		firePowsterCustomEvent('synopsis-download_image', 'synopsis', imageName);
	});

	Store.on('SYNOPSIS_ENLARGE_IMAGE', (imageName = 'onesheet.jpg') => {
		firePowsterCustomEvent('synopsis-enlarge_image', 'synopsis', imageName);
	});

	Store.on('GALLERY_VIEW_IMAGE', (imageName) => {
		firePowsterCustomEvent('gallery-view_image', 'gallery', imageName);
	});

	Store.on('GALLERY_DOWNLOAD_IMAGE', (imageName) => {
		firePowsterCustomEvent('gallery-image_download', 'gallery', imageName);
	});

	Store.on('GALLERY_DOWNLOAD_ALL', (page) => {
		firePowsterCustomEvent('gallery-image_download_all', 'gallery', `${page ? page : '-'}`);
	});

	Store.on('VIDEO_PLAYER_PROGRESS', ({ platform, video, step, time, isShowtimesMessage, isTrailerOverlay }) => {
		const progress = step === 95 ? 100 : step;
		let category = isTrailerOverlay ? 'trailer' : 'videos';
		let action = `${category}${isShowtimesMessage ? '-empty' : ''}-watch`;
		let label = video + '_' + platform + '_' + progress;
		firePowsterCustomEvent(action, category, label);

		let event = 'video_milestone';
		if (step === 0) {
			event = 'video_start';
		} else if (step === 100) {
			event = 'video_complete';
		}
		tealiumActionTrack({
			tealium_event: event,
			video_playhead: time,
			video_id: video,
			video_platform: 'YouTube'
		});
	});

	Store.on('MAP_REQUEST_DIRECTIONS', (travelMode) => {
		firePowsterCustomEvent('map-request_direction', 'map', travelMode.toLowerCase());
	});

	Store.on('SELECT_THEATER', (theater, source, ticketType = 'tickets') => {
		const name = theater.name || '';
		const chain = accessNested(theater, 'chain.name', '');
		const concatChainName = name + '-' + chain;

		firePowsterCustomEvent(ticketType + '-select-theatre_chain', ticketType, concatChainName);
		fireLionsgateSelectTheater(name);
		tealiumActionTrack({
			action: source === 'map' ? 'placeSelectFromMap' : 'cinemaSelect',
			...tealiumTheaterData(theater)
		});
	});

	Store.on('GROUP_BOOKINGS_INQUIRE', theater => {
		const name = theater.name || '';
		const chain = accessNested(theater, 'chain.name', '');
		const concatChainName = name + '-' + chain;

		firePowsterCustomEvent('groupbookings-inquire', 'groupbookings', concatChainName);
	});

	Store.on('GROUP_BOOKINGS_NAVIGATE_STAGES', direction => {
		firePowsterCustomEvent('groupbookings-navigate-stages', 'groupbookings', direction);
	});

	Store.on('GROUP_BOOKINGS_SUBMIT', theater => {
		const name = theater.name || '';
		const chain = accessNested(theater, 'chain.name', '');
		const concatChainName = name + '-' + chain;
		firePowsterCustomEvent('groupbookings-submit', 'groupbookings', concatChainName);
	});

	Store.on('GROUP_BOOKINGS_INQUIRE', theater => {
		const name = theater.name || '';
		const chain = accessNested(theater, 'chain.name', '');
		const concatChainName = name + '-' + chain;

		firePowsterCustomEvent('groupbookings-inquire', 'groupbookings', concatChainName);
	});

	// Click on a time (either open interstitial or link out if only one provider available)
	// Use ticket conversion for all link outs - interstitial or not
	Store.on('SELECT_TIME', (data, page) => {
		if (!page) page = 'tickets';
		const { screening, theater } = data;
		if (!screening || !theater) {
			return;
		}
		firePowsterCustomEvent('tickets-interstitial', page, `${theater.name}_${theater.chain?.name}_${screening.date}_${screening.time}_${screening.format}`);

		let dateTime = null;
		if (screening.date) {
			dateTime = parseDate(screening.date);
			dateTime.setHours(...screening.time.split(':'));
		}
		tealiumActionTrack({
			action: 'timeSelect',
			...tealiumTheaterData(theater),
			targetLink: screening.link.direct,
			format: screening.format,
			showDateTime: dateTime?.toISOString(),
			dateSelected: screening.date
		});

		fireLionsgateTicketClick(screening, theater);
	});

	Store.on('TICKET_CONVERSION', (data, page) => {
		let parsedDate = parseDate(data.date);
		if (!page) page = 'tickets';
		const { ticketType = 'tickets' } = data;
		// Keeping this for now for legacy reasons
		firePowsterCustomEvent(ticketType + '-select-calendar_date', page, data.date);

		// firePowsterCustomEvent('tickets-select-calendar_day', page, formatDateTime(parsedDate, 'dddd'));
		// firePowsterCustomEvent('tickets-select-calendar_time', page, data.time);
		// firePowsterCustomEvent('tickets-select-format', page, data.format);
		// firePowsterCustomEvent('tickets-select-provider', page, data.provider);
		// firePowsterCustomEvent('tickets-conversion', page, data.conversion);
		// firePowsterCustomEvent('tickets-source', page, data.source);

		firePowsterCustomEvent(ticketType + '-conversion', 'tickets', data.conversion, {
			date: data.date,
			day: formatDateTime(parsedDate, 'dddd'),
			time: data.time,
			format: data.format,
			provider: data.provider,
			source: data.source,
		});
		updateDataLayerConversion(data);
	});

	Store.on('PREVIEW_PANEL_THEATER_CLICK', (theater, chain) => {
		firePowsterCustomEvent('theater-click', 'previewpanel', theater + '_' + chain);
	});

	Store.on('PREVIEW_PANEL_MORE_SHOWTIMES_CLICK', () => {
		firePowsterCustomEvent('more-showtimes-click', 'previewpanel', '-');
	});

	Store.on('PREVIEW_PANEL_MORE_MERCHANTS_CLICK', () => {
		firePowsterCustomEvent('more-ways-to-watch-click', 'previewpanel', '-');
	});

	Store.on('PREVIEW_PANEL_TOGGLE_VIEW', (view) => {
		firePowsterCustomEvent('toggle-view', 'previewpanel', view);
	});

	Store.on('PREVIEW_PANEL_EXTRA_BUTTON_CLICK', (label) => {
		firePowsterCustomEvent('extra-button-click', 'previewpanel', label);
	});

	Store.on('WRONG_REGION', (region, ticketType = 'tickets') => {
		firePowsterCustomEvent(ticketType + '-redirect_origin', ticketType, region);
	});

	Store.on('SHOWTIMES_ERROR', (ticketType = 'tickets') => {
		firePowsterCustomEvent(ticketType + '-error', ticketType, '-');
	});

	Store.on('SHOWTIMES_EMPTY', (region, ticketType = 'tickets') => {
		const location = `${region.countryCode || 'X'}-${region.city || 'X'}`;

		firePowsterCustomEvent(ticketType + '-no_showtimes', ticketType, location);
	});

	Store.on('FILTER_SELECTED_TIME', (times, ticketType = 'tickets') => {
		if (times) {
			times.split(',').forEach(time => {
				firePowsterCustomEvent(ticketType + '-filter_time', ticketType, time);
			});
		} else {
			firePowsterCustomEvent(ticketType + 'filter_time', ticketType, 'Any time');
		}
	});

	Store.on('FILTER_SELECTED_DAY', (date, ticketType = 'tickets') => {
		const formattedDate = date.split('-').reverse().join('/');

		firePowsterCustomEvent(ticketType + 'filter_date', ticketType, formattedDate);
	});

	Store.on('FILTER_SELECTED_FORMAT', (formats, ticketType = 'tickets') => {
		if (formats) {
			formats.split(',').forEach(format => {
				firePowsterCustomEvent(ticketType + '-filter_format', ticketType, format);
			});
		} else {
			firePowsterCustomEvent(ticketType + '-filter_format', ticketType, 'Any format');
		}
	});

	Store.on('GEO_FROM_IP', (geo, ticketType = 'tickets') => {
		const location = `${geo.city || 'X'}-${geo.countryCode || 'X'}`;

		firePowsterCustomEvent(ticketType + '-location-origin', ticketType, location);
	});

	Store.on('REGION_SELECTOR_CLICKED', (origin, destination) => {
		const label = origin.toLowerCase() + '-' + destination.toLowerCase();
		firePowsterCustomEvent('origin', 'region', label);
	});

	Store.on('SET_USER_LOCATION', (data, source, ticketType = 'tickets') => {
		if (source !== 'landing') {
			firePowsterCustomEvent(ticketType + '-search', ticketType, '-');
			updateDataLayerCitySearch(data);
		}
		if (source === 'suggestion') {
			tealiumActionTrack({
				action: 'cinemaSearch',
				searchPhrase: data && data.city
			});
		}
	});
	Store.on('USER_LOCATION_UPDATED', async ({ geo, source, ticketType = 'tickets' }) => {
		if (source === 'landing' || !geo) {
			return;
		}

		firePowsterCustomEvent(ticketType + '-location-update', ticketType, `${geo.city || 'X'}_${geo.countryCode || 'X'}`);
		if (source === 'nearby') {
			tealiumActionTrack({
				action: 'moreShowTimes',
				location: geo.city
			});
		}
	});

	Store.on('MOVIE_DETAILS_BUTTON_CLICK', (page, label) => {
		firePowsterCustomEvent(page + '-button-click', page, label);
	});

	Store.on('HEADER_PERSISTENT_BUTTON_CLICK', (action, category, label, options) => {
		firePowsterCustomEvent(action, category, label, options);
	});

	Store.on('TOUT_CLICK', (toutType, category, label, options) => {
		firePowsterCustomEvent('tout-click-' + toutType, category, label, options);
	});

	Store.on('NOTIFICATION_BANNER_CLICK', (action, category, label, options) => {
		firePowsterCustomEvent(action, category, label, options);
	});

	Store.on('TEXT_LIST_CLICK', (label) => {
		firePowsterCustomEvent('textlistitem-click', 'textlistitem', label);
	});

	Store.on('POWSTER_GA_EVENT_TRACK', (action, category, label, options) => {
		firePowsterCustomEvent(action, category, label, options);
	});

	Store.on('POWSTER_GA_PAGE_VIEW_TRACK', (pageId) => {
		firePowsterGtagPageView(pageId);
	});

	Store.on('FILTER_SET', (filter, value) => {
		if (filter === 'date') {
			tealiumActionTrack({
				action: 'dateSelect',
				dateSelected: value
			});
		}
	});
	Store.on('FILTER_TOGGLE', (filter, value) => {
		if (filter === 'format') {
			tealiumActionTrack({
				action: 'formatSelect',
				format: value
			});
		}
	});

	Store.on('TRACK_FILTERS_CHANGE', (filters) => {
		updateDataLayerFilters(filters);
	});

	Store.on('TRACK_NAV_LINK_CLICK', (linkName) => {
		if (linkName) {
			tealiumActionTrack({
				action: 'menuSelect',
				actionValue: linkName
			});
		}
	});

	// HOME ENT
	Store.on('HOME_ENT_CONVERSION', (data, page) => {
		if (!page) page = 'homeent';
		const { merchant, selectedFormat, availability, product, dataProvider, region } = data;
		firePowsterCustomEvent('homeent-provider', page, dataProvider);
		firePowsterCustomEvent('homeent-availability_select', page, `${region}-${availability}`);
		firePowsterCustomEvent('homeent-conversion', page, `${region}_${selectedFormat}_${availability}_${merchant}_${product.edition || 'absent'}_${product.price || 'absent'}`);
	});

	Store.on('HOME_ENT_FORMAT_SELECT', (format) => {
		firePowsterCustomEvent('homeent-format_select', 'homeent', format);
	});

	Store.on('HOME_ENT_MERCHANT_SELECT', (data, page) => {
		const cat = page || 'homeent';
		const { region, merchant } = data;
		if (!region || region === 'loading') return;
		firePowsterCustomEvent('homeent-merchant_select', cat, `${region}-${merchant}`);
	});

	Store.on('HOME_ENT_PROVIDER_ATTRIBUTION_CLICK', (provider) => {
		firePowsterCustomEvent('homeent-dynamic_attribution_select', 'homeent', provider);
	});
}
